module.exports = __webpack_public_path__ + "img/doctor-icon.7c2cbc06.webp";